export const MentionsDataParam = {
  ObjectId: 'data-rocketlane-mention-object-id',
  ProjectId: 'data-rocketlane-mention-project-id',
  SpaceId: 'data-rocketlane-mention-space-id',
  Identifier: 'data-rocketlane-mention-identifier',
  Type: 'data-rocketlane-mention-type',
  SubType: 'data-rocketlane-mention-sub-type',
};
